export default "__VITE_ASSET__C$JW5pCU__"